import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderInterface } from '@core/interfaces/loader.interface';

import {
  BounceBarsLoaderComponent,
} from '@modules/loaders/components/loader-types/bounce-bars-loader/bounce-bars-loader.component';
import {
  BounceDotsLoaderComponent,
} from '@modules/loaders/components/loader-types/bounce-dots-loader/bounce-dots-loader.component';
import {
  GrowingBarsLoaderComponent,
} from '@modules/loaders/components/loader-types/growing-bars-loader/growing-bars-loader.component';
import {
  InfinityLoaderComponent,
} from '@modules/loaders/components/loader-types/infinity-loader/infinity-loader.component';
import {
  MusicBarsLoaderComponent,
} from '@modules/loaders/components/loader-types/music-bars-loader/music-bars-loader.component';
import {
  RotatingSquareLoaderComponent,
} from '@modules/loaders/components/loader-types/rotating-square-loader/rotating-square-loader.component';
import {
  SpinnerLoaderComponent,
} from '@modules/loaders/components/loader-types/spinner-loader/spinner-loader.component';
import { TimeLoaderComponent } from '@modules/loaders/components/loader-types/time-loader/time-loader.component';
import { LoaderHelper } from '@modules/loaders/helpers/loader-helper';

import { WebsiteLoader } from '@modules/loaders/interfaces/website-loader.interface';
import { LoaderService } from '@modules/loaders/services/loader.service';

@Component({
  selector: 'app-loaders-wrapper',
  templateUrl: './loaders-wrapper.component.html',
  styleUrls: ['./loaders-wrapper.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgSwitch,
    SpinnerLoaderComponent,
    NgSwitchCase,
    InfinityLoaderComponent,
    TimeLoaderComponent,
    RotatingSquareLoaderComponent,
    GrowingBarsLoaderComponent,
    MusicBarsLoaderComponent,
    BounceDotsLoaderComponent,
    BounceBarsLoaderComponent,
  ],
})
export class LoadersWrapperComponent extends LoaderHelper {
  showSpinner = true;
  private timeout: any;

  constructor(loaderService: LoaderService) {
    super();

    loaderService.loader.subscribe((result: LoaderInterface) => {
      // const time = result.display ? 0 : 1000;
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(
      //   () => (this.showSpinner = result.display),
      // time
      // );
      this.showSpinner = result.display;
    });
    loaderService.composedLoaderSettings.subscribe((result: WebsiteLoader) => {
      if (!result) {
        return;
      }
      this.loader = result;
    });
  }
}
